// extracted by mini-css-extract-plugin
module.exports = {"cartBtn":"CartBtnMobile-module--cartBtn--1do1C","tab":"CartBtnMobile-module--tab--3fRQs","snyrtivara":"CartBtnMobile-module--snyrtivara--2Gyuf"};